import React from "react";
import {createPortal} from "react-dom";
import "./index.scss";
import logo from "images/logo/marchio.svg";

export const LoadingLogo = () => {
    return <div className="loading-logo">
        <img src={logo} alt={"loading logo"} />
    </div>
};

export const LoadingLogoPortal = props => createPortal(
    <div className={"portal"}><LoadingLogo {...props}/></div>,
    document.body
);